declare global {
  interface Array<T> {
    sum(selector: (row: T) => number | undefined): number;
  }
}

if (!Array.prototype.sum) {
  Array.prototype.sum = function <T>(
    selector: (row: T) => number | undefined,
  ): number {
    return this.reduce<number>((sum, row) => sum + (selector(row) ?? 0), 0);
  };
}

export { };

